import { render, staticRenderFns } from "./live-tool.vue?vue&type=template&id=218f0a89&scoped=true&"
import script from "./live-tool.vue?vue&type=script&lang=js&"
export * from "./live-tool.vue?vue&type=script&lang=js&"
import style0 from "./live-tool.vue?vue&type=style&index=0&id=218f0a89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f0a89",
  null
  
)

export default component.exports